import React from "react";
import Footer from "../components/Footer";
import EmbeddedNav from "../components/EmbeddedNav";

function CheckIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" className="text-pink-500" fill="none">
      <path d="M20 6L9 17l-5-5" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function TrustIcon({ type }) {
  const common = "w-5 h-5 text-slate-500";
  if (type === "shield") {
    return (
      <svg className={common} viewBox="0 0 24 24" fill="none">
        <path d="M12 3l8 4v6c0 5-3.5 9-8 10-4.5-1-8-5-8-10V7l8-4z" stroke="currentColor" strokeWidth="2" />
        <path d="M9 12l2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (type === "privacy") {
    return (
      <svg className={common} viewBox="0 0 24 24" fill="none">
        <path d="M12 2a7 7 0 017 7v3h1a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2v-6a2 2 0 012-2h1V9a7 7 0 017-7z" stroke="currentColor" strokeWidth="2" />
        <path d="M8 12V9a4 4 0 118 0v3" stroke="currentColor" strokeWidth="2" />
      </svg>
    );
  }
  return (
    <svg className={common} viewBox="0 0 24 24" fill="none">
      <path d="M4 4h16v16H4V4z" stroke="currentColor" strokeWidth="2" />
      <path d="M8 16l2-2 2 2 4-4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function AboutPage() {
  return (
    <div className="min-h-screen">
      <main className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10 bg-gradient-to-br from-white via-pink-50 to-slate-50" />
        <div className="absolute inset-0 -z-10 sparkle-overlay" />

        <div className="absolute -top-28 -right-24 h-[520px] w-[520px] rounded-full bg-pink-200 glow-blob -z-10" />
        <div className="absolute top-32 -left-40 h-[560px] w-[560px] rounded-full bg-pink-200/70 glow-blob -z-10" />

        <div className="w-full">
          <div className="px-6 md:px-10 pt-7 md:pt-8 pb-10 md:pb-12">
            <EmbeddedNav />
            <div className="mt-10 grid md:grid-cols-2 gap-10 items-start">
              <div>
                <h1 className="text-3xl md:text-4xl font-bold tracking-tight text-slate-900">
                  About Zebra MicroWealth
                </h1>
                <p className="mt-3 text-slate-600 leading-relaxed max-w-xl">
                  We help South Africans access quick, simple personal loans with transparent estimates.
                </p>
              </div>

              <div className="md:justify-self-end relative">
                <div className="absolute -top-10 -right-10 h-56 w-56 rounded-full bg-pink-200/60 glow-blob" />
                <div className="glass rounded-3xl px-6 py-5 w-full md:w-[360px] relative">
                  <div className="space-y-2.5 text-sm">
                    <div className="flex items-center gap-2">
                      <CheckIcon />
                      <span className="font-semibold text-slate-900">R1,000–R2,000</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <CheckIcon />
                      <span className="text-slate-700">Quick review</span>
                    </div>
                    <div className="flex items-center gap-2">
                      <CheckIcon />
                      <span className="text-slate-700">Simple terms</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-10 grid md:grid-cols-2 gap-6">
              <div className="glass rounded-3xl p-7">
                <h3 className="text-lg font-semibold text-slate-900">Our Mission</h3>
                <p className="mt-2 text-slate-600 leading-relaxed">
                  Empowering financial freedom for South Africans by offering quick, safe, and simple microloans to
                  achieve your personal goals.
                </p>
              </div>

              <div className="glass rounded-3xl p-7">
                <h3 className="text-lg font-semibold text-slate-900">Core Values</h3>
                <ul className="mt-3 space-y-2.5 text-sm text-slate-700">
                  <li className="flex items-start gap-2"><CheckIcon /><span>Transparent estimates</span></li>
                  <li className="flex items-start gap-2"><CheckIcon /><span>Fair lending practices</span></li>
                  <li className="flex items-start gap-2"><CheckIcon /><span>Privacy and security</span></li>
                  <li className="flex items-start gap-2"><CheckIcon /><span>Local community support</span></li>
                </ul>
              </div>
            </div>

            <div className="mt-8 flex flex-wrap items-center gap-6 text-sm text-slate-600">
              <div className="flex items-center gap-2">
                <TrustIcon type="shield" />
                <span>Secure application</span>
              </div>
              <div className="flex items-center gap-2">
                <TrustIcon type="privacy" />
                <span>Privacy-first</span>
              </div>
              <div className="flex items-center gap-2">
                <TrustIcon type="estimate" />
                <span>Transparent estimates</span>
              </div>
            </div>

            <div className="mt-10 glass rounded-3xl p-7 flex flex-col items-center text-center">
              <h3 className="text-xl font-semibold text-slate-900">Ready to apply?</h3>
              <a
                href="https://5577-8888.webfin.co.za/webloans/"
                className="mt-4 inline-flex items-center justify-center rounded-xl px-8 py-3.5 text-sm font-semibold text-white
                           bg-gradient-to-r from-pink-400 to-pink-600 shadow-lg shadow-pink-500/25
                           hover:brightness-105 active:scale-[0.99] transition"
              >
                Apply Now
              </a>
            </div>
          </div>
        </div>

        <Footer />
      </main>
    </div>
  );
}
